import { HeadProvider, Title } from 'react-head';
import { useLocation, useParams } from 'react-router-dom';
import findTitle from './helper';

function Head() {
    const location = useLocation();
    const { appID = '' } = useParams();

    const contentPageTitle = appID
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    const { title } = findTitle(location?.pathname ?? '/');
    const pageTitle = contentPageTitle || title;
    return (
        <HeadProvider>
            <Title>{pageTitle}</Title>
        </HeadProvider>
    );
}

export default Head;
